import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=ce989bac&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"
import style0 from "./Stats.vue?vue&type=style&index=0&id=ce989bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce989bac",
  null
  
)

export default component.exports